import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable no-unused-vars */

/*
 * @Author: wangshengqiang
 * @Date: 2021-04-25 11:28:08
 * @LastEditTime: 2022-03-01 15:20:43
 * @LastEditors: wangshengqiang
 * @Description: 试算逻辑
 */
import React, { useEffect } from 'react';
import { getQueryParam } from '@/utils';
import { getFetchBaseData } from '@/utils/utils';
import ZaToast from '@/components/ZaToast/index.js';
import request from '@/utils/request';
import { dispatch, getState } from '@/store';
import SingleAlert from '@/components/SingleAlert/singleAlert';
import { isPreviewMode } from '@/utils/tool';
import { useApp } from '@/hooks'; // 调用试算接口，返回试算结果

export const getCalculatedPremium = async onTrialComplete => {
  // 试算传入订单号, 更新订单信息
  const data = getFetchBaseData();
  const {
    orderNo,
    encryptOrderNo
  } = getQueryParam();
  data.orderNo = orderNo;
  data.encryptOrderNo = encryptOrderNo; // data.thirdChannelCode=  "QD202103257276";
  // data.extraInfo = {
  //   canalDefine: '',
  //   originAccount: '127229',
  //   originChannel: 'QD202103257276',
  //   thirdChannelCode: 'QD202103257276',
  // };

  const opts = {
    method: 'POST',
    data
  };
  const res = (await request('/v1/insure/premiumCalculate', opts)) || {};
  const {
    code,
    message,
    result
  } = res;

  if (Number(code)) {
    const codeList = ['20000', '20019'];

    if (codeList.includes(code)) {
      const modal = SingleAlert({
        title: '温馨提示',
        content: message,
        onCancel: () => {
          modal.hide();
        }
      });
      return;
    }

    ZaToast.show(message);
    return;
  } // 把试算结果存到store中


  if (onTrialComplete) {
    onTrialComplete(result);
  } else {
    const premium = getState('premium');
    const {
      payType,
      initialPremium,
      nextPremium
    } = result;
    dispatch('premium', _objectSpread(_objectSpread(_objectSpread({}, premium), result), {}, {
      type: payType == '1' ? 'year' : 'month',
      value: payType == '1' ? initialPremium : [initialPremium, nextPremium]
    }));
  }
};

const Trial = ({
  children,
  onTrialComplete
}) => {
  const {
    form
  } = useApp();
  const formValuesStr = form.getFieldsValue(undefined, fieldMeta => {
    return fieldMeta.isPremiumFactor;
  });

  const fetchPremium = () => {
    getCalculatedPremium(onTrialComplete);
  };

  useEffect(() => {
    setTimeout(() => {
      const names = form.getFieldsName(meta => meta.isPremiumFactor);

      if (!names || names.length < 1 || isPreviewMode()) {
        console.log('没有配置试算因子或者为预览环境');
        return;
      }

      form.validateFields(names, {
        noUpdate: true
      }).then((val, err) => {
        fetchPremium();
      }).catch(e => {
        console.log('error: 试算', 'error');
      });
    }, 500);
  }, [JSON.stringify(formValuesStr)]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

export default Trial;